import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'bg-system-gray-900 flex flex-col',
    closeButton:
      'link text-icon-main-inversion flex items-center gap-2 px-2 pb-2',
    main: 'mb-[24px] flex flex-row items-center justify-between px-[12px] py-[17px]',
    logo: '',
    logoIcon: 'w-full max-w-[144px]',
    close: '',
    closeIcon: 'size-[28px] [&>path]:stroke-white',
    search: 'opacity-0',
    searchIcon: 'size-[28px] [&>path]:fill-white'
  },
  defaultVariants: {}
});
